module.exports = __webpack_public_path__ + "static/media/vatican-flag.c53f51a9.png";